exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".HistoricalDownload__anchor___D_uMC{color:#000;font-size:20px}", ""]);

// exports
exports.locals = {
	"anchor": "HistoricalDownload__anchor___D_uMC"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/assets/HistoricalDownload/HistoricalDownload.pcss
// module id = 868
// module chunks = 0